/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Boundary_TitleInputs */

const en_us2_errors_boundary_title = /** @type {(inputs: Errors_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, something went wrong`)
};

const pt_br2_errors_boundary_title = /** @type {(inputs: Errors_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desculpe, algo deu errado`)
};

const es_419_errors_boundary_title = /** @type {(inputs: Errors_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo sentimos, algo salió mal`)
};

const pt_pt2_errors_boundary_title = /** @type {(inputs: Errors_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desculpa, algo correu mal`)
};

const fr_fr2_errors_boundary_title = /** @type {(inputs: Errors_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désolé, un problème est survenu`)
};

const de_de2_errors_boundary_title = /** @type {(inputs: Errors_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entschuldige, da ist etwas schiefgelaufen`)
};

const it_it2_errors_boundary_title = /** @type {(inputs: Errors_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scusa, qualcosa è andato storto`)
};

/**
* | output |
* | --- |
* | "Sorry, something went wrong" |
*
* @param {Errors_Boundary_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const errors_boundary_title = /** @type {((inputs?: Errors_Boundary_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Boundary_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_errors_boundary_title(inputs)
	if (locale === "es-419") return es_419_errors_boundary_title(inputs)
	if (locale === "pt-PT") return pt_pt2_errors_boundary_title(inputs)
	if (locale === "fr-FR") return fr_fr2_errors_boundary_title(inputs)
	if (locale === "de-DE") return de_de2_errors_boundary_title(inputs)
	if (locale === "it-IT") return it_it2_errors_boundary_title(inputs)
	return en_us2_errors_boundary_title(inputs)
});
export { errors_boundary_title as "errors-boundary.title" }